import * as React from "react";
import { Helpers } from "@grandvisionhq/inventory";
/* empty css                      */
import { UpdateLineItemContainer } from "../../../../containers/modules/LineItems/containers/UpdateLineItemContainer.js";
import { DuplicateLineItemContainer } from "../../../../containers/modules/LineItems/containers/DuplicateLineItemContainer.js";
import { RemoveLineItemContainer } from "../../../../containers/modules/LineItems/containers/RemoveLineItemContainer.js";
import { useCart } from "../../../../../../context/Cart/context/Cart/context.js";
const QuantitySelector = ({
  lineItemId,
  isReadOnly,
  shouldShowQuantity,
  shouldShowDuplicateButton
}) => {
  const { cart } = useCart();
  const lineItem = cart?.lineItems.filter(
    (lineItem2) => lineItem2.id === lineItemId
  )[0];
  if (!lineItem) {
    return null;
  }
  return !isReadOnly && !lineItem.isGift ? /* @__PURE__ */ React.createElement("div", { className: "line-item__quantity" }, /* @__PURE__ */ React.createElement("div", { className: "line-item__quantity-selector" }, shouldShowQuantity && /* @__PURE__ */ React.createElement(
    UpdateLineItemContainer,
    {
      lineItem,
      availableQuantity: Helpers.getAvailableQuantity(lineItem.availability)
    }
  ), shouldShowDuplicateButton && /* @__PURE__ */ React.createElement(DuplicateLineItemContainer, { lineItem }), /* @__PURE__ */ React.createElement("div", { className: "line-item__delete-btn" }, /* @__PURE__ */ React.createElement(RemoveLineItemContainer, { lineItem })))) : null;
};
export {
  QuantitySelector
};
//# sourceMappingURL=QuantitySelector.js.map
